import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import {
	type HttpExperienceShellItineraryPositionOptions,
	httpExperienceShellItineraryPosition
} from '../http/experience-shell.http'
import type { Itinerary } from '../types'

export const useExpItinerariesPosition = ({
	urlParams,
	options
}: {
	urlParams: HttpExperienceShellItineraryPositionOptions['urlParams']
	options?: Omit<
		UseMutationOptions<
			Itinerary[],
			unknown,
			HttpExperienceShellItineraryPositionOptions['payload'],
			unknown
		>,
		'mutationFn'
	>
}) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload) =>
			httpExperienceShellItineraryPosition({
				urlParams,
				payload,
				params: { responseType: 'extended' }
			}),
		...options,
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE, urlParams.experienceId]
			})
			//queryClient.setQueriesData({queryKey: [QUERY_KEYS.EXPERIENCE, urlParams.experienceId]}, data)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
